import { Typography } from "@graphy/ui";
import Image from "next/image";

interface CaptionWithImgProps {
  caption: string;
  imgSrc: string;
}

export const CaptionWithImg = ({ caption, imgSrc }: CaptionWithImgProps) => {
  return (
    <div className="flex items-center gap-[6px]">
      <Image src={imgSrc} alt={caption} width={14} height={14} />
      <Typography
        fontSize="text-caption"
        colorClass="text-grey-4"
        fontWeight="font-light"
      >
        {caption}
      </Typography>
    </div>
  );
};
